const adminToApi = () => {
  const redirectTo = {};
  redirectTo["http://localhost:8080"] = "http://localhost:8080";
  redirectTo["https://cloud.iucommons.com"] = "https://api.iucommons.com";
  redirectTo["https://commons-admin.pages.dev"] = "https://api.iucommons.com";

  return redirectTo;
};

export { adminToApi };
